import React, { Component } from 'react';
import moment from 'moment';
import { Form, Checkbox, Radio } from 'semantic-ui-react';
import { DateInput } from 'semantic-ui-calendar-react';
import { updateInPath } from '../../../../common/utils/utils.js';
import I18nTabs from '../../../common/components/I18nTabs';


export default class EventForm extends Component {
  constructor(props) {
    super();

    this.state = props.data;
  }
  
  updateState = (name, value) => {
    this.setState(prevState => {
      const newState = updateInPath(prevState, name, value);
      this.props.onUpdate(newState);
      return newState;
    });
  };

  handleChange = (e, {name, value}) => {
    this.updateState(name, value);
  };

  handleToggle = (e, {name, checked}) => {
    this.updateState(name, checked);
  };

  render() {
    const {
      title = '',
      location = '',
      beginDate = '',
      endDate = '',
      type = 'COMPETITION',
      registrationEnabled = false,
      published = false,
      i18n_description = {}
    } = this.state;

    const i18nArr = [
      { name: 'i18n_description', value: i18n_description, desc: 'Description' }
    ];

    return (
      <Form>
        <Form.Group>
          <Form.Input
            width={8}
            disabled={!!this.props.data.id}
            required label='Title (min. 5 characters)'
            placeholder='Robotex 2018'
            name='title'
            value={title}
            onChange={this.handleChange}/>
          <Form.Group width={8}>
            <Form.Field>
              <Radio
                name='type'
                label='Competition'
                value='COMPETITION'
                checked={type === 'COMPETITION'}
                onChange={this.handleChange}
              />
            </Form.Field>
            <Form.Field>
              <Radio
                name='type'
                label='Workshop'
                value='WORKSHOP'
                checked={type === 'WORKSHOP'}
                onChange={this.handleChange}
              />
            </Form.Field>
          </Form.Group>
        </Form.Group>
        <Form.Input
          label='Location'
          placeholder='e.g. Tallinn, Estonia'
          name='location'
          value={location}
          onChange={this.handleChange} />
        <Form.Group widths='equal'>
          <DateInput
            required
            dateFormat='YYYY-MM-DD'
            minDate={moment()}
            label="Begin date"
            name="beginDate"
            value={beginDate}
            iconPosition="left"
            onChange={this.handleChange} />
          <DateInput
            required
            dateFormat='YYYY-MM-DD'
            minDate={moment()}
            label="End date"
            name="endDate"
            value={endDate}
            iconPosition="left"
            onChange={this.handleChange} />
        </Form.Group>
        <I18nTabs
          data={i18nArr}
          onChange={this.handleChange}/>
        <Form.Field
          control={Checkbox}
          label='Registration is open'
          name='registrationEnabled'
          checked={registrationEnabled}
          onChange={this.handleToggle} />
        <Form.Field
          control={Checkbox}
          label='Published (event is made public and visible to all the users)'
          name='published'
          checked={published}
          onChange={this.handleToggle} />
      </Form>
    );
  }
}



// WEBPACK FOOTER //
// ./src/private/admin/components/Event/Form.js